export const deleteDocumentAdminService = (fetch) => async (document) => {
  try {
    const response = await fetch({ url: `/api/v1/documentos-admin/${document}`, method: 'delete' })
    return response
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
